import AbsComponent from '../../components/AbsComponent';
import Checkbox from '../components/Checkbox';
import Radio from '../components/Radio';

export default class SideMain extends AbsComponent {
    constructor(_name = '', _store = {}, _actions = {}, _router = {}, _el = '') {
        super(_name, _store, _actions, _router, _el);

        const sidegrade = new Checkbox(
            'SideGrade',
            this.store,
            this.actions,
            this.router,
            '.gameinfo-filter__list .grade article',
            'grades',
            '/game/grades'
        );
        const sidecardtype = new Checkbox(
            'SideCardtype',
            this.store,
            this.actions,
            this.router,
            '.gameinfo-filter__list .cardtype article',
            'card',
            '/game/polymorph/card-types'
        );
        const sidebuffcardtype = new Radio(
            'SideBuffcardtype',
            this.store,
            this.actions,
            this.router,
            '.gameinfo-filter__list .polymorphtype article',
            'buffcard',
            '/game/polymorph/buff-card-types'
        );
        const sideweapontype = new Checkbox(
            'SideWeapontype',
            this.store,
            this.actions,
            this.router,
            '.gameinfo-filter__list .weapontype article',
            'weapon',
            '/game/weapon-types'
        );

        $('.gameinfo-filter__title .btn-refresh').on('click', (e) => {
            this.router.goMultiParam({
                grades: '',
                card: '',
                buffcard: '',
                weapon: '',
                page: 1,
            });
        });

        $('.gameinfo-filter-wrapper .btn-close').on('click', (e) => {
            $('.gameinfo-filter-wrapper').removeClass('is-active');
        });
    }
} // end of class
